import { render } from "./SettingsPanel.vue?vue&type=template&id=b8f3cab0&scoped=true"
import script from "./SettingsPanel.vue?vue&type=script&lang=js"
export * from "./SettingsPanel.vue?vue&type=script&lang=js"

import "./SettingsPanel.vue?vue&type=style&index=0&id=b8f3cab0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b8f3cab0"

export default script